import { ChartType } from "../../../services/cloudchipr.api";

export const chartTypeFromRechartToHighCharts = (
  chartType: ChartType,
): ChartType => {
  if (chartType === "stack") {
    return "stacked_column";
  }

  if (chartType === "bar") {
    return "column";
  }

  return chartType;
};
